import React, { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "redux-i18n";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import * as modalActions from "../../redux/actions/modalActions";
import * as commonActions from "../../redux/actions/commonAction";
import * as profileActions from "../../redux/actions/profileAction";
import * as userAuthActions from "../../redux/actions/userAuthAction";
import Report from '../../components/Report';
import Sidebar from '../../components/Sidebar';
import { ShowForPermission } from '../../components/UserAuth/ShowForPermissionComponent';
import { PERMISSION_TYPE, PERMISSON_MODULES } from '../../Permission.config';
import { PREFERED_LANGUAGE_KEYS } from '../../App.config';

const ReportPage = (props, context) => {
    const profileReducer = useSelector((state) => state.profileReducer);
    const commonReducer = useSelector((state) => state.commonReducer);
    const userAuthReducer = useSelector((state) => state.userAuthReducer);
    const i18nReducer = useSelector((state) => state.i18nState);

    const dispatch = useDispatch();

    const modalAction = bindActionCreators(modalActions, dispatch);
    const commonAction = bindActionCreators(commonActions, dispatch);
    const profileAction = bindActionCreators(profileActions, dispatch);
    const userAuthAction = bindActionCreators(userAuthActions, dispatch);

    const getAllCompanyList = () => userAuthAction.getAllCompanyList();

    useEffect(() => {
        getAllCompanyList();
    }, [])

    const UpdateReportAccess = (reportId, companyId, roleId, isAccess) => {
        userAuthAction.updateReportAccess(companyId, roleId, isAccess, reportId);
    }

    const GetReportsByCompany = (companyId) => {
        const isLangEng = i18nReducer.lang == PREFERED_LANGUAGE_KEYS.EnglishUS
        companyId ? userAuthAction.getReportDetailsByCompany(companyId,isLangEng) : userAuthAction.resetReport([]);
    }

    const deleteReport = (companyId, reportId) => {
        userAuthAction.deleteReportByCompanyId(companyId, reportId);
    }

    const languageChange = (language) => {
        dispatch(setLanguage(language));
    };

    const onMenuToggle = (isOpen) => {
        commonAction.setIsSideMenuOpen(isOpen);
    };

    const openSetModal = (children, size) => {
        modalAction.openSetModal(children, size);
    };

    const closeRemoveModal = () => {
        modalAction.closeRemoveModal();
    };

    return (
        <>
            {window.location.hash !== "#/" && (
                <Sidebar
                    languageChange={languageChange}
                    openSetModalAction={openSetModal}
                    closeRemoveModal={closeRemoveModal}
                    managersDetails={profileReducer.managersDetails}
                    onMenuToggle={onMenuToggle}
                    isSideMenuOpen={commonReducer.isSideMenuOpen}
                    context={context}
                />
            )}
            <div className="Content-Panel">
                <ShowForPermission module={PERMISSON_MODULES.REPORT_SETTING} permission={PERMISSION_TYPE.VIEW}>
                    <Report
                        deleteReport={deleteReport}
                        context={context}
                        userAuthReducer={userAuthReducer}
                        GetReportsByCompany={GetReportsByCompany}
                        i18nReducerLang={i18nReducer.lang}
                        UpdateReportAccess={UpdateReportAccess}
                        openSetModalAction={openSetModal}
                        closeRemoveModal={closeRemoveModal}
                    />
                </ShowForPermission>
                {/* <ShowForPermission module={PERMISSON_MODULES.FILE_UPLOADS_PAGE} permission={PERMISSION_TYPE.VIEW}>
                    

                </ShowForPermission> */}
            </div>
        </>
    )
}

ReportPage.contextTypes = {
    t: PropTypes.func.isRequired,
};
export default ReportPage;